<template>
  <div>
    <el-card shadow="nerver">
      <el-breadcrumb separator="/">
        <!-- separator 分隔符 -->
        <el-breadcrumb-item :to="{ name: 'product' }">产品库</el-breadcrumb-item>
        <el-breadcrumb-item>添加产品</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <!-- 编辑的tab：可浮动 -->
    <el-card class="add-product-tabs"
             shadow="nerver">
      <el-tabs v-model="activeName"
               @tab-click="handleProductTabs">
        <el-tab-pane label="基本信息"
                     name="1"></el-tab-pane>
        <el-tab-pane label="服务商"
                     name="2"></el-tab-pane>
        <el-tab-pane label="套餐设置"
                     name="3"></el-tab-pane>
        <el-tab-pane label="行前通知"
                     name="4"></el-tab-pane>
      </el-tabs>
    </el-card>
    <!-- 基本信息 -->
    <spu-setting ref="spu"></spu-setting>
    <!-- 产品说明-->
    <el-card class="add-product-info-content"
             shadow="nerver">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>产品简介</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="add-product-info-content"
             shadow="nerver">
      <div style="margin: 0 10px 20px">
        <editor-info ref="editor"></editor-info>
      </div>
    </el-card>
    <!-- 套餐设置 -->
    <!-- <sku-setting ref="sku"></sku-setting> -->
    <!-- 详情设置 -->
    <!-- <el-card class="add-product-info-header" shadow="nerver">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>确认单信息</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>-->

    <el-card class="add-product-info-content"
             shadow="nerver">
      <!-- 编辑器 -->
      <!-- <editor-info ref="editor"></editor-info> -->
      <div class="add-product-info-submit">
        <el-button class="submit-area"
                   @click="submitProd"
                   size="mini"
                   type="primary">提交</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import SkuSetting from '../../components/product/SkuSetting'
import SpuSetting from '../../components/product/SpuSetting'
import AddtionlaSetting from '../../components/product/AddtionalSetting'
import Editor from '../../components/common/editor/editorV1'
export default {
  name: 'product_add',
  components: {
    'sku-setting': SkuSetting,
    'spu-setting': SpuSetting,
    'addtional-setting': AddtionlaSetting,
    'editor-info': Editor,
  },
  data() {
    return {
      activeName: '1',
    }
  },
  methods: {
    handleProductTabs() {
      window.scrollTo(0, 200)
    },
    submitProd() {
      // 产品
      let out_spu_id = this.$refs.spu.out_spu_id
      // console.log(this.$refs.spu.prodnum);
      let spu_name = this.$refs.spu.spu_name
      let dest = this.$refs.spu.selectDests
      // console.log(this.$refs.sku.editableTabs);
      // console.log(this.$refs.editor.introduce);
      let spu_introduce = this.$refs.editor.introduce

      // 套餐
      // let sku_info = this.$refs.sku.editableTabs;

      let spu_img = this.$refs.spu.image_url
      if (out_spu_id == '' && spu_name == '' && dest == '') {
        this.$alert('有必填项为空，请补充', '警告')
      }

      const product_info = {}
      ;(product_info.out_spu_id = out_spu_id),
        (product_info.spu_name = spu_name),
        (product_info.dest = dest),
        (product_info.spu_detail = spu_introduce),
        (product_info.spu_avatar = spu_img),
        // (product_info.skus = sku_info);
        // console.log(product_info);
        // return;
        this.$http.post('/product/add_product', product_info).then((res) => {
          // console.log(res);

          if (res.data.errno == '0') {
            this.$notify({
              title: '成功',
              message: '保存新品成功！',
              type: 'success',
            })
            // 跳转到产品管理页

            this.$router.push({
              path: `/product-intro`,
              query: { spu_id: `${res.data.spu_id}` },
            })
            window.scrollTo(0, 0)
          } else {
            this.$notify({
              title: '错误',
              message: res.data.errmsg,
              type: 'warning',
            })
          }
        })
    },
  },
}
</script>

<style>
.add-product-tabs {
  margin-top: 10px;
}
.add-product-tabs .el-card__body {
  padding: 0px 20px;
}
.add-product-info-header {
  border-radius: 3px 3px 0px 0px;
  margin-top: 10px;
}
.add-product-info-header .el-card__body {
  padding: 15px 20px 15px 20px;
}
.add-product-info-content {
  border-radius: 0px 0px 3px 3px;
}
.content-line {
  margin-bottom: 10px;
}
.add-product-info-submit {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.submit-area {
  margin-top: 50px;
  width: 200px;
}
</style>